// The raiders players choose from. Each is a ready-made character drawn by
// avatar2d.js; a player's choice is saved on their account as
// `avatar3d: { character: "<id>" }` (the field name predates the 2D art), or
// a raider they built themselves (see BUILDER below).
// Players who haven't chosen get one picked from their user id, so it is the
// same on every device and for their opponents.

const DEFAULTS = {
  body: "male", skin: "#f5c39e", eyes: "#2b1f2a", ears: "round",
  hair: "short", hairColour: "#4a3020", face: "none", headwear: "none",
  outfit: "tunic", outfitColour: "#7a5230", trim: "#f2c94c",
  legColour: "#3b4252", bootColour: "#5b3b2a",
  weapon: "none", shield: "none", shieldColour: "#b5651d",
};
const ch = (id, name, look) => ({ id, name, look: { ...DEFAULTS, ...look } });
const F = { body: "female" };

export const CHARACTERS = [
  ch("viking", "Viking", { hair: "short", hairColour: "#e2a33c", face: "beard", headwear: "viking", legColour: "#6b4a35", weapon: "axe", shield: "round" }),
  ch("valkyrie", "Valkyrie", { ...F, skin: "#ffdbc2", eyes: "#3f6fb0", hair: "braids", hairColour: "#e2a33c", headwear: "winged", outfit: "armour", outfitColour: "#1b4f72", weapon: "spear", shield: "round", shieldColour: "#c0392b" }),
  ch("knight", "Knight", { skin: "#ffdbc2", headwear: "knight", outfit: "armour", outfitColour: "#2e86de", trim: "#c0392b", legColour: "#8e979f", bootColour: "#59616b", weapon: "sword", shield: "kite", shieldColour: "#2e86de" }),
  ch("paladin", "Paladin", { ...F, skin: "#e0a47a", eyes: "#3e8a4c", hair: "long", hairColour: "#4a3020", headwear: "helm", outfit: "armour", outfitColour: "#f4ecd8", legColour: "#8e979f", bootColour: "#59616b", weapon: "hammer", shield: "kite", shieldColour: "#f4ecd8" }),
  ch("wizard", "Wizard", { skin: "#ffdbc2", eyes: "#3f6fb0", hair: "bald", hairColour: "#f1f1f1", face: "bigbeard", headwear: "wizard", outfit: "robe", outfitColour: "#6c3fb5", legColour: "#4a2f7a", weapon: "staff" }),
  ch("sorceress", "Sorceress", { ...F, eyes: "#3e8a4c", hair: "long", hairColour: "#c0392b", headwear: "wizard", outfit: "dress", outfitColour: "#16a085", weapon: "staff", orb: "#4fd1ff" }),
  ch("rogue", "Rogue", { skin: "#e0a47a", hairColour: "#1d1a19", face: "mask", headwear: "hood", outfitColour: "#2f3e46", trim: "#c0392b", bootColour: "#2c2c2c", weapon: "daggers" }),
  ch("assassin", "Assassin", { ...F, skin: "#c68356", eyes: "#7b5a3a", hair: "ponytail", hairColour: "#1d1a19", face: "mask", outfit: "leather", outfitColour: "#2f3e46", trim: "#7d4fd6", bootColour: "#2c2c2c", weapon: "daggers" }),
  ch("archer", "Archer", { eyes: "#3e8a4c", hair: "long", hairColour: "#e2a33c", headwear: "ranger", outfitColour: "#4b8b3b", trim: "#c0392b", legColour: "#7a5230", bootColour: "#7a5230", weapon: "bow" }),
  ch("huntress", "Huntress", { ...F, skin: "#9c6440", eyes: "#3e8a4c", hair: "ponytail", hairColour: "#4a3020", face: "warpaint", outfit: "leather", outfitColour: "#4b8b3b", trim: "#e67e22", legColour: "#7a5230", weapon: "bow" }),
  ch("orc", "Orc", { skin: "#6fbf5a", ears: "pointy", hair: "mohawk", hairColour: "#c0392b", face: "tusks", outfit: "leather", outfitColour: "#a0522d", trim: "#c2a878", legColour: "#5b3b2a", bootColour: "#3d2a1e", weapon: "spear", shield: "round", shieldColour: "#8e979f" }),
  ch("warchief", "Warchief", { ...F, skin: "#6fbf5a", ears: "pointy", hair: "braids", hairColour: "#1d1a19", face: "tusks", outfit: "leather", outfitColour: "#7a5230", trim: "#c0392b", bootColour: "#3d2a1e", weapon: "axe", shield: "round", shieldColour: "#a0522d" }),
  ch("pirate", "Pirate", { skin: "#e0a47a", hair: "long", hairColour: "#1d1a19", face: "eyepatch", headwear: "pirate", outfitColour: "#c0392b", legColour: "#f4ecd8", bootColour: "#2c2c2c", weapon: "sword" }),
  ch("corsair", "Pirate Queen", { ...F, eyes: "#3f6fb0", hair: "curly", hairColour: "#8a5a2b", headwear: "pirate", outfitColour: "#1b4f72", legColour: "#2c2c2c", bootColour: "#2c2c2c", weapon: "sword" }),
  ch("king", "King", { skin: "#c68356", hair: "short", hairColour: "#4a3020", face: "beard", headwear: "crown", outfit: "robe", outfitColour: "#c0392b", weapon: "sword", shield: "kite", shieldColour: "#c0392b" }),
  ch("queen", "Queen", { ...F, skin: "#6e4429", eyes: "#7b5a3a", hair: "curly", hairColour: "#1d1a19", headwear: "crown", outfit: "dress", outfitColour: "#8e44ad", weapon: "staff", orb: "#f2c94c" }),
  ch("barbarian", "Barbarian", { skin: "#c68356", hair: "long", hairColour: "#1d1a19", face: "warpaint", headwear: "bandana", outfit: "leather", outfitColour: "#7a5230", trim: "#c0392b", legColour: "#5b3b2a", weapon: "hammer" }),
  ch("druid", "Druid", { ...F, eyes: "#3e8a4c", ears: "pointy", hair: "bun", hairColour: "#38c27a", headwear: "tiara", outfit: "robe", outfitColour: "#4b8b3b", trim: "#c2a878", weapon: "staff", orb: "#7ee36b" }),
  ch("necromancer", "Necromancer", { skin: "#b7c4c9", eyes: "#16a085", headwear: "hood", outfit: "robe", outfitColour: "#2c2c2c", trim: "#16a085", legColour: "#1f2430", bootColour: "#2c2c2c", weapon: "staff", orb: "#38e0b0" }),
  ch("frost", "Frost Elf", { ...F, skin: "#cfe6f7", eyes: "#3f6fb0", ears: "pointy", hair: "long", hairColour: "#f1f1f1", headwear: "tiara", outfit: "armour", outfitColour: "#3d7bf0", trim: "#bfe8ff", legColour: "#1b4f72", bootColour: "#1b4f72", weapon: "sword", shield: "kite", shieldColour: "#bfe8ff" }),
];

const BY_ID = Object.fromEntries(CHARACTERS.map((c) => [c.id, c]));

// Bots with a raider of their own, by bot name; other bots get a default
// picked from their name. Magnus: a cartoon chess grandmaster with big
// messy hair, a short dark beard and a crown (Jack, 2026-10-18).
const BOT_CHARACTERS = {
  magnus: ch("magnus", "Magnus", { skin: "#f7cfae", eyes: "#4a6f9a", hair: "messy", hairColour: "#7a5232", face: "stubble", headwear: "crown", outfitColour: "#22314f", trim: "#e9edf2", legColour: "#3a3f4a", bootColour: "#1f1f24" }),
};

export function botCharacter(name) {
  return BOT_CHARACTERS[String(name || "").toLowerCase()] || characterFor(`bot:${name || "bot"}`);
}

// ── Building your own ──
// Every choice in the builder, grouped as the builder shows them. A custom
// raider is saved as `avatar3d: { character: "custom", look: {...} }`. The
// server checks every value against the same lists (server.py), and looks
// from other players are checked again here before they are drawn.
const C = (id, label) => ({ id, label });
export const BUILDER = {
  body: [
    { key: "body", label: "Build", options: [C("male", "Broad"), C("female", "Slim")] },
    { key: "skin", label: "Skin", colours: ["#ffdbc2", "#f5c39e", "#e0a47a", "#c68356", "#9c6440", "#6e4429", "#6fbf5a", "#b7c4c9", "#cfe6f7"] },
    { key: "ears", label: "Ears", options: [C("round", "Round"), C("pointy", "Pointy")] },
    { key: "eyes", label: "Eyes", colours: ["#2b1f2a", "#7b5a3a", "#3f6fb0", "#3e8a4c", "#16a085", "#7d4fd6"] },
    { key: "hair", label: "Hair", options: [C("short", "Short"), C("spiky", "Spiky"), C("swept", "Swept"), C("parted", "Parted"), C("long", "Long"), C("curly", "Curly"), C("ponytail", "Ponytail"), C("braids", "Braids"), C("bun", "Bun"), C("mohawk", "Mohawk"), C("bald", "Bald")] },
    { key: "hairColour", label: "Hair colour", colours: ["#1d1a19", "#4a3020", "#8a5a2b", "#e2a33c", "#c0392b", "#f1f1f1", "#38c27a", "#3d7bf0", "#e0457a"] },
    { key: "face", label: "Face", options: [C("none", "Plain"), C("beard", "Beard"), C("stubble", "Stubble"), C("bigbeard", "Big beard"), C("moustache", "Moustache"), C("tusks", "Tusks"), C("warpaint", "War paint"), C("eyepatch", "Eyepatch"), C("mask", "Mask")] },
  ],
  attire: [
    { key: "headwear", label: "Headwear", options: [C("none", "None"), C("viking", "Viking"), C("winged", "Winged"), C("helm", "Helm"), C("knight", "Knight"), C("wizard", "Wizard"), C("ranger", "Ranger"), C("hood", "Hood"), C("crown", "Crown"), C("tiara", "Tiara"), C("bandana", "Bandana"), C("pirate", "Pirate"), C("santa", "Santa hat")] },
    { key: "outfit", label: "Outfit", options: [C("tunic", "Tunic"), C("armour", "Armour"), C("leather", "Leather"), C("robe", "Robe"), C("dress", "Dress"), C("majestic", "Majestic")] },
    { key: "outfitColour", label: "Outfit colour", colours: ["#7a5230", "#c0392b", "#e67e22", "#4b8b3b", "#16a085", "#1b4f72", "#2e86de", "#6c3fb5", "#8e44ad", "#2f3e46", "#2c2c2c", "#f4ecd8"] },
    { key: "trim", label: "Trim", colours: ["#f2c94c", "#c0392b", "#f4ecd8", "#c2a878", "#16a085", "#7d4fd6", "#e67e22", "#bfe8ff"] },
    { key: "legColour", label: "Trousers", colours: ["#3b4252", "#5b3b2a", "#7a5230", "#8e979f", "#1b4f72", "#4a2f7a", "#2c2c2c", "#f4ecd8"] },
    { key: "bootColour", label: "Boots", colours: ["#5b3b2a", "#7a5230", "#3d2a1e", "#59616b", "#1b4f72", "#2c2c2c"] },
    { key: "weapon", label: "Weapon", options: [C("none", "None"), C("sword", "Sword"), C("axe", "Axe"), C("hammer", "Hammer"), C("spear", "Spear"), C("staff", "Staff"), C("daggers", "Daggers"), C("bow", "Bow"), C("gloves", "Boxing gloves"), C("crystal", "Crystal ball")] },
    { key: "orb", label: "Staff orb", colours: ["#9b59ff", "#4fd1ff", "#f2c94c", "#7ee36b", "#38e0b0", "#ff6b6b"], when: (L) => L.weapon === "staff" },
    { key: "shield", label: "Shield", options: [C("none", "None"), C("round", "Round"), C("kite", "Kite")], when: (L) => !["bow", "daggers", "gloves", "crystal"].includes(L.weapon) },
    { key: "shieldColour", label: "Shield colour", colours: ["#b5651d", "#8e979f", "#c0392b", "#2e86de", "#f4ecd8", "#a0522d", "#bfe8ff"], when: (L) => L.shield !== "none" && !["bow", "daggers", "gloves", "crystal"].includes(L.weapon) },
  ],
};
// Only for the accounts the server allows: option -> the user flag that
// unlocks it, and the badge shown on the option.
export const RESTRICTED = {
  outfit: { majestic: { flag: "admin_outfit", badge: "Admin" } },
  weapon: { gloves: { flag: "boxing_gloves", badge: "Only you" }, crystal: { flag: "admin_outfit", badge: "Admin" } },
};

const HEX = /^#[0-9a-f]{6}$/i;
const ALLOWED = {};
for (const f of [...BUILDER.body, ...BUILDER.attire]) {
  ALLOWED[f.key] = f.options ? new Set(f.options.map((o) => o.id)) : null;
}

// A look that is safe to draw: every value from the lists above (colours any
// #rrggbb), anything else falls back to the default.
export function cleanLook(look) {
  const out = { ...DEFAULTS };
  if (!look || typeof look !== "object") return out;
  for (const key of Object.keys(ALLOWED)) {
    const v = look[key];
    if (typeof v !== "string") continue;
    if (ALLOWED[key] ? ALLOWED[key].has(v) : HEX.test(v)) out[key] = v;
  }
  return out;
}

export function customCharacter(look) {
  return { id: "custom", name: "Your raider", look: cleanLook(look) };
}

// Small string hash so a user id always picks the same character.
function hash(s) {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) h = Math.imul(h ^ s.charCodeAt(i), 16777619);
  return h >>> 0;
}

export function defaultCharacterId(seed) {
  return CHARACTERS[hash(String(seed || "guest")) % CHARACTERS.length].id;
}

// The character to show for a player: their saved choice, else their default.
export function characterFor(userId, saved) {
  if (saved && typeof saved === "object" && saved.character === "custom" && saved.look) {
    return customCharacter(saved.look);
  }
  const id = saved && typeof saved === "object" ? saved.character : saved;
  return BY_ID[id] || BY_ID[defaultCharacterId(userId)];
}

// ── Saving ──
// The choice is saved on the account. When the backend doesn't know the
// endpoint yet (a preview pointed at the live server), it is kept in this
// browser instead so picking still works end to end.
const LOCAL_KEY = (id) => `jangle.character.${id}`;

export function localCharacter(userId) {
  try {
    return localStorage.getItem(LOCAL_KEY(userId));
  } catch {
    return null;
  }
}

export function setLocalCharacter(userId, id) {
  try { localStorage.setItem(LOCAL_KEY(userId), id); } catch { /* ignore */ }
}

// Your own character: server copy first, then this browser's, then default.
export function myCharacter(user) {
  if (!user) return characterFor("guest");
  if (user.avatar3d?.character === "custom") return characterFor(user.id, user.avatar3d);
  return characterFor(user.id, user.avatar3d?.character || localCharacter(user.id));
}
